import type { SurfacedItem } from '@app/core';

import { HeatBar } from './HeatBar.js';

interface QueuePreviewProps {
  items: SurfacedItem[];
  maxVisible: number;
  onSelect: (index: number) => void;
}

export function QueuePreview({ items, maxVisible, onSelect }: QueuePreviewProps) {
  if (items.length === 0 || maxVisible === 0) return null;

  const visible = items.slice(0, maxVisible);

  return (
    <nav
      aria-label="Upcoming items"
      style={{
        maxWidth: '480px',
        width: '100%',
        margin: 'var(--space-lg) auto 0',
      }}
    >
      <ul
        style={{
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-sm)',
        }}
      >
        {visible.map(surfaced => (
          <li key={surfaced.item.id}>
            <button
              onClick={() => {
                onSelect(surfaced.queuePosition);
              }}
              style={{
                width: '100%',
                textAlign: 'left',
                background: 'var(--color-card)',
                border: '1px solid var(--color-card-border)',
                borderRadius: 'var(--radius-md)',
                padding: 'var(--space-md)',
                color: 'var(--color-text-primary)',
                cursor: 'pointer',
                transition: 'background var(--transition-fast)',
              }}
              aria-label={surfaced.item.text}
            >
              <div style={{ fontSize: '0.875rem', marginBottom: 'var(--space-xs)' }}>
                {surfaced.item.text}
              </div>
              <HeatBar temperature={surfaced.temperature} />
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
